import { SearchOutlined } from "@ant-design/icons";
import { Button, Col, Form, Input, Row, Select, Space } from "antd";
import React, { useContext } from "react";
import { DATA_MASTER_DATA_TYPE, PERMISSION } from "../../../../lib/const";
import useMasterData from "../../../../lib/hooks/useMasterData";
import { SearchRoleContext } from "../searchContext";

const { Option } = Select;

const Search = () => {
  const [searchForm] = Form.useForm();
  const [permissions] = useMasterData(DATA_MASTER_DATA_TYPE, PERMISSION);
  const { setSearchValues, setFetchData, setPageValues } =
    useContext(SearchRoleContext);

  const onSearch = (values) => {
    setSearchValues({
      roleName: values?.roleName,
      permissionId: values?.permissionId,
    });
    setFetchData(true);
  };

  const handleClearSearchForm = () => {
    setFetchData(true);
    searchForm.resetFields();

    setSearchValues({ roleName: "", permissionId: "" });
    setPageValues({
      page: 0,
      pageSize: 10,
      sortBy: "roleNameTh",
      sortDirection: "DESC",
    });
  };

  return (
    <div className="card search_section">
      <Form
        form={searchForm}
        name="search"
        onFinish={onSearch}
        colon={false}
        style={{ marginBottom: "20px" }}
      >
        <Row gutter={24} className="search-form">
          <Col span={12}>
            <Form.Item name={"roleName"}>
              <Input
                style={{ fontSize: 16 }}
                placeholder={"ชื่อ Role"}
                prefix={<SearchOutlined className="site-form-item-icon" />}
              />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item name={"permissionId"}>
              <Select
                allowClear
                placeholder={"Permission"}
                style={{ fontSize: 16 }}
              >
                {permissions?.map((option, i) => (
                  <Option key={option.dataId} value={option.dataId}>
                    {option.dataDetailTh}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={24} className="search-form" style={{ paddingTop: 10 }}>
          <Col span={24} align="right">
            <Space>
              <Button onClick={handleClearSearchForm}>ล้างข้อมูล</Button>
              <Button type="primary" htmlType="submit">
                ค้นหา
              </Button>
            </Space>
          </Col>
        </Row>
      </Form>
    </div>
  );
};

export default Search;
